import React, { useEffect, useState } from "react";
import { adminClient } from "../../../lib/admin";

const LABELS = {
  newsletter_leads: "Newsletter Leads",
  seller_applications: "Seller Applications",
  shop_seller_applications: "Shop Seller Applications",
  external_marketplace_requests: "External Marketplace Requests",
  affiliate_interest_leads: "Affiliate Interest",
  sebara_card_requests: "Sebara Card Requests",
  contact_messages: "Contact Messages",
  certificates: "Certificate Records",
  product_sync_logs: "Product Sync / Checkout Logs",
};
const ORDER = Object.keys(LABELS);
const STATUSES = ["new", "in_review", "approved", "contacted", "closed"];

export default function AdminLeads() {
  const client = adminClient();
  const [counts, setCounts] = useState({});
  const [active, setActive] = useState("newsletter_leads");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => { client.get("/admin/summary").then(({ data }) => setCounts(data.counts)).catch(() => {}); }, []);
  useEffect(() => {
    setLoading(true);
    client.get(`/admin/leads/${active}`).then(({ data }) => setItems(data.items)).catch(() => {}).finally(() => setLoading(false));
  }, [active]);

  const updateStatus = async (id, status) => {
    await client.put(`/admin/leads/${active}/${id}`, { status });
    setItems(items.map((it) => (it.id === id ? { ...it, status } : it)));
  };

  const columns = items[0] ? Object.keys(items[0]).filter((k) => !["id", "source_page", "updated_at"].includes(k)) : [];

  return (
    <div data-testid="admin-leads">
      <h2 className="text-xl font-black font-display mb-5">Leads & Records</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-6">
        {ORDER.map((c) => (
          <button key={c} onClick={() => setActive(c)} data-testid={`admin-tab-${c}`} className={`text-left p-4 border transition-colors ${active === c ? "bg-taven-black text-white border-taven-black" : "bg-white border-black/10 hover:border-taven-gold"}`}>
            <p className="text-2xl font-black">{counts[c] ?? "—"}</p>
            <p className="text-xs font-semibold uppercase tracking-wider mt-1 opacity-80">{LABELS[c]}</p>
          </button>
        ))}
      </div>
      <div className="bg-white border border-black/10 overflow-x-auto">
        <div className="px-4 py-3 border-b border-black/10 font-bold uppercase tracking-wider text-sm">{LABELS[active]}</div>
        {loading ? <div className="p-8 text-center text-muted-foreground">Loading...</div> :
          items.length === 0 ? <div className="p-8 text-center text-muted-foreground">No records yet.</div> :
            <table className="w-full text-sm">
              <thead className="bg-taven-gray/60"><tr>{columns.map((c) => <th key={c} className="text-left px-3 py-2 font-bold uppercase text-[10px] tracking-wider whitespace-nowrap">{c.replace(/_/g, " ")}</th>)}<th className="px-3 py-2 text-left text-[10px] uppercase tracking-wider">Set Status</th></tr></thead>
              <tbody>
                {items.map((it) => (
                  <tr key={it.id} className="border-t border-black/5 align-top">
                    {columns.map((c) => <td key={c} className="px-3 py-2 max-w-[220px] truncate" title={String(it[c])}>{c === "created_at" ? new Date(it[c]).toLocaleString() : String(it[c] ?? "")}</td>)}
                    <td className="px-3 py-2"><select value={it.status} onChange={(e) => updateStatus(it.id, e.target.value)} className="border border-black/15 px-2 py-1 text-xs">{STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}</select></td>
                  </tr>
                ))}
              </tbody>
            </table>}
      </div>
    </div>
  );
}
